import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { InjectionToken, Injector, Component, Inject, ViewChild, NgModule, Injectable } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import * as i1 from '@angular/material/snack-bar';
import { MAT_SNACK_BAR_DATA, MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBarModule } from '@angular/material/snack-bar';
import * as i5 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i4 from '@xpo-ltl/ngx-ltl-core/button';
import { XpoButtonModule } from '@xpo-ltl/ngx-ltl-core/button';
import * as i3 from '@xpo-ltl/ngx-ltl-core/icon';
import { XpoIconModule } from '@xpo-ltl/ngx-ltl-core/icon';

const _c0 = ["detailedMessage"];
const _c1 = ["detailedMessageComponent"];
function XpoNotificationTemplate_xpo_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "xpo-icon", 9);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("iconName", ctx_r0.iconName);
} }
function XpoNotificationTemplate_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelementStart(1, "a", 11);
    i0.ɵɵlistener("click", function XpoNotificationTemplate_div_6_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.data.linkAction.function(); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.data.linkAction.message, " ");
} }
function XpoNotificationTemplate_div_7_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("routerLink", ctx_r8.data.linkRoute);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r8.data.linkMessage);
} }
function XpoNotificationTemplate_div_7_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("href", ctx_r10.data.linkRoute, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r10.data.linkMessage);
} }
function XpoNotificationTemplate_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, XpoNotificationTemplate_div_7_a_1_Template, 2, 2, "a", 12);
    i0.ɵɵtemplate(2, XpoNotificationTemplate_div_7_ng_template_2_Template, 2, 2, "ng-template", null, 13, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r9 = i0.ɵɵreference(3);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.data.isInternalRoute)("ngIfElse", _r9);
} }
const _c2 = function (a0) { return { "xpo-Notification-message-detailedMessage--hasScroll": a0 }; };
function XpoNotificationTemplate_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16, 17);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c2, ctx_r3.hasScroll));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.data.detailedMessage, " ");
} }
function XpoNotificationTemplate_div_9_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c3 = function (a0) { return { "xpo-Notification-message-detailedMessageComponent--hasScroll": a0 }; };
function XpoNotificationTemplate_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18, 19);
    i0.ɵɵtemplate(2, XpoNotificationTemplate_div_9_ng_container_2_Template, 1, 0, "ng-container", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c3, ctx_r4.hasScroll));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngComponentOutlet", ctx_r4.data.detailedMessageComponent)("ngComponentOutletInjector", ctx_r4.detailedMessageComponentInjector);
} }
function XpoNotificationTemplate_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelementStart(1, "xpo-icon", 22);
    i0.ɵɵlistener("click", function XpoNotificationTemplate_div_10_Template_xpo_icon_click_1_listener() { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.close(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
/** The injection token to use for detailed message component data */
const XPO_SNACKBAR_DETAILED_MESSAGE_DATA = new InjectionToken('XPO_SNACKBAR_DETAILED_MESSAGE_DATA');
class XpoNotificationTemplate {
    constructor(snackBarRef, data, injector, cdRef) {
        this.snackBarRef = snackBarRef;
        this.cdRef = cdRef;
        /** Used to determine if need to add the class or not*/
        this.hasScroll = false;
        // keep the injected data
        this.data = data;
        // define the icon name
        this.iconName = XpoNotificationTemplate.iconMap[data.status];
        // create the injector for the detailed message component
        this.detailedMessageComponentInjector = Injector.create({
            providers: [{ provide: XPO_SNACKBAR_DETAILED_MESSAGE_DATA, useValue: this.data.detailedMessageComponentData }],
            parent: injector
        });
        this.notificationMesageSubscription = this.snackBarRef.afterOpened().subscribe(() => {
            const element = this.detailedMessage || this.detailedMessageComponent;
            this.hasScroll = (element === null || element === void 0 ? void 0 : element.nativeElement.scrollHeight) > (element === null || element === void 0 ? void 0 : element.nativeElement.offsetHeight);
            this.cdRef.detectChanges();
        });
    }
    ngOnDestroy() {
        this.notificationMesageSubscription.unsubscribe();
    }
    /** Performs the action on the snack bar. */
    close() {
        this.snackBarRef.dismissWithAction();
    }
    /** Returns the host class according to the snackbar status */
    getStatusClasses() {
        return `xpo-Notification xpo-Notification--${this.data.status}`;
    }
}
/** Maps the icon name according to each status */
XpoNotificationTemplate.iconMap = {
    success: 'checkmark-alt',
    warn: 'warning',
    error: 'error',
    info: 'info',
};
XpoNotificationTemplate.ɵfac = function XpoNotificationTemplate_Factory(t) { return new (t || XpoNotificationTemplate)(i0.ɵɵdirectiveInject(i1.MatSnackBarRef), i0.ɵɵdirectiveInject(MAT_SNACK_BAR_DATA), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
XpoNotificationTemplate.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoNotificationTemplate, selectors: [["xpo-notification-template"]], viewQuery: function XpoNotificationTemplate_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.detailedMessage = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.detailedMessageComponent = _t.first);
    } }, hostVars: 2, hostBindings: function XpoNotificationTemplate_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵclassMap(ctx.getStatusClasses());
    } }, decls: 11, vars: 7, consts: [[1, "xpo-Notification-icon"], [3, "iconName", 4, "ngIf"], [1, "xpo-Notification-message"], [1, "xpo-Notification-message-mainWrapper"], [1, "xpo-Notification-message-mainMessage"], ["class", "xpo-Notification-message-link", 4, "ngIf"], ["class", "xpo-Notification-message-detailedMessage", 3, "ngClass", 4, "ngIf"], ["class", "xpo-Notification-message-detailedMessageComponent", 3, "ngClass", 4, "ngIf"], ["class", "xpo-Notification-closeButton", 4, "ngIf"], [3, "iconName"], [1, "xpo-Notification-message-link"], ["xpo-link", "", 3, "click"], ["routerLinkActive", "active", "xpo-link", "", 3, "routerLink", 4, "ngIf", "ngIfElse"], ["externalRoute", ""], ["routerLinkActive", "active", "xpo-link", "", 3, "routerLink"], ["target", "_blank", "xpo-link", "", 3, "href"], [1, "xpo-Notification-message-detailedMessage", 3, "ngClass"], ["detailedMessage", ""], [1, "xpo-Notification-message-detailedMessageComponent", 3, "ngClass"], ["detailedMessageComponent", ""], [4, "ngComponentOutlet", "ngComponentOutletInjector"], [1, "xpo-Notification-closeButton"], ["xpoIconLarge", "", "iconName", "close", 3, "click"]], template: function XpoNotificationTemplate_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, XpoNotificationTemplate_xpo_icon_1_Template, 1, 1, "xpo-icon", 1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, XpoNotificationTemplate_div_6_Template, 3, 1, "div", 5);
        i0.ɵɵtemplate(7, XpoNotificationTemplate_div_7_Template, 4, 2, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(8, XpoNotificationTemplate_div_8_Template, 3, 4, "div", 6);
        i0.ɵɵtemplate(9, XpoNotificationTemplate_div_9_Template, 3, 5, "div", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(10, XpoNotificationTemplate_div_10_Template, 2, 0, "div", 8);
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.iconName);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.data.message);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.data == null ? null : ctx.data.linkAction);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.data == null ? null : ctx.data.linkRoute) && (ctx.data == null ? null : ctx.data.linkMessage));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.data == null ? null : ctx.data.detailedMessage);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.data == null ? null : ctx.data.detailedMessageComponent);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !(ctx.data == null ? null : ctx.data.hideClose));
    } }, directives: [i2.NgIf, i3.XpoIcon, i4.XpoLink, i5.RouterLinkWithHref, i5.RouterLinkActive, i2.NgClass, i2.NgComponentOutlet, i3.XpoIconLarge], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}.xpo-Notification[_nghost-%COMP%]{align-items:flex-start;display:flex;height:100%}.xpo-Notification--success[_nghost-%COMP%]{background-color:#4caf50}.xpo-Notification--warn[_nghost-%COMP%]{background-color:#ffd600}.xpo-Notification--error[_nghost-%COMP%]{background-color:#d32f2f}.xpo-Notification--info[_nghost-%COMP%]{background-color:#2196f3}.xpo-Notification--success[_nghost-%COMP%]{color:#fff}.xpo-Notification--success[_nghost-%COMP%]   .xpo-Link[_ngcontent-%COMP%]{color:#fff;font-weight:400}.xpo-Notification--warn[_nghost-%COMP%]{color:#333}.xpo-Notification--warn[_nghost-%COMP%]   .xpo-Link[_ngcontent-%COMP%]{color:#333;font-weight:400}.xpo-Notification--error[_nghost-%COMP%]{color:#fff}.xpo-Notification--error[_nghost-%COMP%]   .xpo-Link[_ngcontent-%COMP%]{color:#fff;font-weight:400}.xpo-Notification--info[_nghost-%COMP%]{color:#fff}.xpo-Notification--info[_nghost-%COMP%]   .xpo-Link[_ngcontent-%COMP%]{color:#fff;font-weight:400}.xpo-Notification--success[_nghost-%COMP%]   .xpo-Notification-closeButton[_ngcontent-%COMP%]{color:#4caf50}.xpo-Notification--success[_nghost-%COMP%]   .xpo-Notification-closeButton[_ngcontent-%COMP%]:hover{color:#fff}.xpo-Notification--warn[_nghost-%COMP%]   .xpo-Notification-closeButton[_ngcontent-%COMP%]{color:#ffd600}.xpo-Notification--warn[_nghost-%COMP%]   .xpo-Notification-closeButton[_ngcontent-%COMP%]:hover{color:#fff}.xpo-Notification--error[_nghost-%COMP%]   .xpo-Notification-closeButton[_ngcontent-%COMP%]{color:#d32f2f}.xpo-Notification--error[_nghost-%COMP%]   .xpo-Notification-closeButton[_ngcontent-%COMP%]:hover{color:#fff}.xpo-Notification--info[_nghost-%COMP%]   .xpo-Notification-closeButton[_ngcontent-%COMP%]{color:#2196f3}.xpo-Notification--info[_nghost-%COMP%]   .xpo-Notification-closeButton[_ngcontent-%COMP%]:hover{color:#fff}.xpo-Notification-icon[_ngcontent-%COMP%]{margin-top:14px;margin-left:16px;height:20px}.xpo-Notification-message[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex-grow:1;padding:12px 16px;height:100%}.xpo-Notification-message-mainWrapper[_ngcontent-%COMP%]{display:flex}.xpo-Notification-message-mainMessage[_ngcontent-%COMP%]{flex-grow:1;font-size:1.143rem}.xpo-Notification-message-detailedMessage[_ngcontent-%COMP%], .xpo-Notification-message-detailedMessageComponent[_ngcontent-%COMP%]{overflow:auto;line-height:20px;margin-top:8px}.xpo-Notification-message-detailedMessage--hasScroll[_ngcontent-%COMP%], .xpo-Notification-message-detailedMessageComponent--hasScroll[_ngcontent-%COMP%]{padding-right:8px}.xpo-Notification-message-link[_ngcontent-%COMP%]{margin-left:16px;white-space:nowrap}.xpo-Notification-closeButton[_ngcontent-%COMP%]{display:flex;align-items:flex-start;justify-content:center;height:100%;width:48px;background-color:#00000026;color:#fff;padding:12px}.xpo-Notification-closeButton[_ngcontent-%COMP%]   .xpo-Icon[_ngcontent-%COMP%]{cursor:pointer}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoNotificationTemplate, [{
        type: Component,
        args: [{
                selector: 'xpo-notification-template',
                templateUrl: 'notification-template.html',
                styleUrls: ['notification-template.scss'],
                host: {
                    '[class]': 'getStatusClasses()',
                },
            }]
    }], function () { return [{ type: i1.MatSnackBarRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_SNACK_BAR_DATA]
            }] }, { type: i0.Injector }, { type: i0.ChangeDetectorRef }]; }, { detailedMessage: [{
            type: ViewChild,
            args: ['detailedMessage']
        }], detailedMessageComponent: [{
            type: ViewChild,
            args: ['detailedMessageComponent']
        }] }); })();

class XpoSnackBarModule {
}
XpoSnackBarModule.ɵfac = function XpoSnackBarModule_Factory(t) { return new (t || XpoSnackBarModule)(); };
XpoSnackBarModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoSnackBarModule });
XpoSnackBarModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
        { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 2500, verticalPosition: 'top' } }
    ], imports: [[
            CommonModule,
            MatIconModule,
            MatSnackBarModule,
            MatButtonModule,
            XpoButtonModule,
            XpoIconModule,
            RouterModule
        ], MatSnackBarModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoSnackBarModule, [{
        type: NgModule,
        args: [{
                declarations: [XpoNotificationTemplate],
                imports: [
                    CommonModule,
                    MatIconModule,
                    MatSnackBarModule,
                    MatButtonModule,
                    XpoButtonModule,
                    XpoIconModule,
                    RouterModule
                ],
                exports: [MatSnackBarModule],
                entryComponents: [XpoNotificationTemplate],
                providers: [
                    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 2500, verticalPosition: 'top' } }
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoSnackBarModule, { declarations: [XpoNotificationTemplate], imports: [CommonModule,
        MatIconModule,
        MatSnackBarModule,
        MatButtonModule,
        XpoButtonModule,
        XpoIconModule,
        RouterModule], exports: [MatSnackBarModule] }); })();

class XpoSnackBar {
    constructor(snackBar) {
        this.snackBar = snackBar;
    }
    success(message, action = '') {
        return this.open({ message, status: 'success', action });
    }
    warn(message, action = '') {
        return this.open({ message, status: 'warn', action });
    }
    error(message, action = '') {
        return this.open({ message, status: 'error', action });
    }
    info(message, action = '') {
        return this.open({ message, status: 'info', action });
    }
    open(params) {
        const { message, status, linkRoute, linkMessage, isInternalRoute, detailedMessage, detailedMessageComponent, detailedMessageComponentData, matConfig, linkAction, hideClose } = params;
        const localConfig = Object.assign({}, matConfig);
        localConfig.data = {
            message,
            status,
            linkRoute,
            linkMessage,
            isInternalRoute,
            detailedMessage,
            detailedMessageComponent,
            detailedMessageComponentData,
            linkAction,
            hideClose
        };
        return this.snackBar.openFromComponent(XpoNotificationTemplate, localConfig);
    }
}
XpoSnackBar.ɵfac = function XpoSnackBar_Factory(t) { return new (t || XpoSnackBar)(i0.ɵɵinject(i1.MatSnackBar)); };
XpoSnackBar.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: XpoSnackBar, factory: XpoSnackBar.ɵfac, providedIn: XpoSnackBarModule });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoSnackBar, [{
        type: Injectable,
        args: [{ providedIn: XpoSnackBarModule }]
    }], function () { return [{ type: i1.MatSnackBar }]; }, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { XPO_SNACKBAR_DETAILED_MESSAGE_DATA, XpoNotificationTemplate, XpoSnackBar, XpoSnackBarModule };
